import React from 'react'

import moment from 'moment'

import { EngagementScoreFlames } from 'components/EngagementScoreFlames'
import { InsightOpportunity } from 'modules/accountActivity/domain'
import { formatDollars } from 'utils/formatNumbers'

import BaseCard from '../BaseCard'
import { CardHeader,CardHeaderExpandProps } from '../CardHeader'
import EmptyCardText from '../EmptyCardText'
import { MemoReadonlyField } from '../Fields'

import styles from './styles.module.css'

export const Header: React.FC<CardHeaderExpandProps> = ({ ...rest }) => {
  return (
    <CardHeader
      data-ocweb-id="DealDetailsCardHeader"
      content={
        <div className={styles.headerContent}>
          <div>Insights</div>
        </div>
      }
      {...rest}
    />
  )
}

interface DetailsCardProps {
  deal?: InsightOpportunity
}

export const Card: React.FC<DetailsCardProps> = ({ deal }) => {
  const hasDataToDisplay = true
  return (
    <BaseCard data-ocweb-id="InsightsCard">
      {!hasDataToDisplay ? (
        <EmptyCardText
          data-ocweb-id="EmptyCompanyText"
          content="We don't have any details for this deal"
        />
      ) : (
        <>
          <MemoReadonlyField
            className={styles.datum}
            label="Total ARR"
            value={deal ? formatDollars(deal.amount) : '-'}
            displayWrap
          />

          <MemoReadonlyField
            className={styles.datum}
            label="Score"
            value={<EngagementScoreFlames score={deal?.score ? deal?.score / 10 : 0} />}
            displayWrap
          />

          <MemoReadonlyField
            className={styles.datum}
            label="Time to close"
            value={deal?.closeDate ? moment(deal.closeDate).fromNow() : 'closed'}
            displayWrap
          />
        </>
      )}
    </BaseCard>
  )
}

export default Card
